import { FormGroup } from '@angular/forms';

export interface IDropdown {
  viewValue: string;
  value: string;
}

export interface IDropDownService {
  guid: string;
  code: string;
  name: string;
}

export interface IDropDownEntityContainer {
  guid: string;
  name: string;
  customer_code?: string;
  employee_code?: string;
  supplier_code?: string;
  merchant_code?: string;
}

export interface SearchModel {
  label;
  dataType;
  form: FormGroup;
  query: (string) => string;
  table?: string;
  joins?;
  queryCallbacks: { [id: string]: (any) => string };
  additionalCondition?: string;
  options?;
}
export abstract class SearchModelClass implements SearchModel {
  label;
  dataType;
  form: FormGroup;
  query: (string) => string;
  table?: string;
  joins?;
  queryCallbacks: { [id: string]: (any) => string };
  additionalCondition?: string;
  options;

  constructor(label, dataType, form, query, table, queryCallbacks, additionalCondition?, options?) {
    this.label = label;
    this.dataType = dataType;
    this.form = form;
    this.query = query;
    this.table = table;
    this.queryCallbacks = queryCallbacks;
    this.additionalCondition = additionalCondition;
    this.options = options;
  }
}

export interface ICustomerDropdown {
  guid: string;
  customer_code: string;
  name: string;
}
